export const userResourceType = 'user';

export const userResourcePath = '/me?include=customer';
